import {connect} from 'react-redux'
import {isLoadingSelector} from 'data/redux/selectors/guiSelector';
import Loader from 'gui/components/Loader';

const mapStateToProps = (state, {loading, ignoreRedux, ...ownProps}) => {
  return {
    loading: loading || (ignoreRedux ? false : isLoadingSelector(state)),
    ...ownProps
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

const LoaderContainer = connect(mapStateToProps, mapDispatchToProps)(Loader) as any;

export default LoaderContainer;
